const ignoreDummyComments = (comment) => {
  let trueComment;
  switch(comment) {
    case '---none':
    case '...':
    case '   ':
    case '  ':
    case ' ':
      trueComment = '';
      break;
    default:
      trueComment = comment;
  }
  return trueComment;
}

export default ignoreDummyComments;



// WEBPACK FOOTER //
// ./src/utils/ignoreDummyComments.js